<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    data(){
        return {
            timer: null,
            latest: Date.now(),
        }
    },
    created(){
        this.init();
    },
    mounted() {
        if (this.accessToken) this.getUser();
    },
    methods: {
        ...mapActions(['getUser']),
        ...mapActions('ui', ['getLogo']),
        init(){
            document.addEventListener("mousemove", () => { this.reset() }, false);
            document.addEventListener("mousedown", () => { this.reset() }, false);
            document.addEventListener("keypress", () => { this.reset() }, false);
            document.addEventListener("touchmove", () => { this.reset() }, false);
            document.addEventListener("onscroll", () => { this.reset() }, false);
            
            this.getLogo();
            this.onTimer();
            this.loadChannelTalk();
            this.setRefid();
        },
        reset(){
            this.latest = Date.now();
        },
        onTimer(){
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if(this.refreshToken){
                    if(60 * 60 * 1000 < (Date.now() - this.latest) || this.payload.exp * 1000 <= Date.now()){
                        this.$store.dispatch("logout");
                    }
                }
                this.onTimer();
            }, 1000);
        },
        loadChannelTalk() {
            (function(){var w=window;if(w.ChannelIO){return w.console.error("ChannelIO script included twice.");}var ch=function(){ch.c(arguments);};ch.q=[];ch.c=function(args){ch.q.push(args);};w.ChannelIO=ch;function l(){if(w.ChannelIOInitialized){return;}w.ChannelIOInitialized=true;var s=document.createElement("script");s.type="text/javascript";s.async=true;s.src="https://cdn.channel.io/plugin/ch-plugin-web.js";var x=document.getElementsByTagName("script")[0];if(x.parentNode){x.parentNode.insertBefore(s,x);}}if(document.readyState==="complete"){l();}else{w.addEventListener("DOMContentLoaded",l);w.addEventListener("load",l);}})();
      
            this.updateChannelTalk();
        },
        updateChannelTalk(){
            ChannelIO('boot', this.channelTalkOption);
        },
        setRefid() {
            console.log({refid:this.refid})
            if (!this.refid) return;
            this.$cookies.set("refid", this.refid);
        },
    },
    computed: {
        refreshToken(){
            return this.$store.state.refreshToken;
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        payload(){
            return JSON.parse(atob(this.refreshToken?.split('.')[1] || '') || "{}");
        },
        user() {
            return this.$store.state.user;
        },
        channelTalkOption() {
            let options = { pluginKey: "751e736b-4e7a-455c-8394-953e99dfbb01" };

            if(this.accessToken) {
                options.memberId= this.user?._id;
                options.profile= {
                    name: this.user?.name,
                    username: this.user?.username,
                    mobileNumber: "82"+this.user?.phone.replace(/-/g, '').slice(1),
                    mail: this.user?.email
                }
            }
            return options;
        },
        removeChannelTalkCookie() {
            const hostname = window.location.hostname;
            let domain = "";

            switch (true) {
                case hostname.includes("localhost"):
                    domain = "";
                    break;
                case hostname.includes("uxi.kr"):
                    domain = ".uxi.kr";
                    break;
                case hostname.includes(".daehanbooks.co.kr"):
                    domain = ".daehanbooks.co.kr";
                    break;
                case hostname.includes("salerbook.net"):
                    domain = ".salerbook.net";
                    break;
                case hostname.includes("salerbook.com"):
                    domain = ".salerbook.com";
                    break;
            }

            this.$cookies.remove("ch-session-180654", "/", domain);
        },
        refid() {
            return this.$route.query.refid;
        },
    },
    watch: {
        accessToken(){
            if(!this.accessToken){
                //채널톡 제거
                this.removeChannelTalkCookie();
                // document.cookie= "ch-session-180654"+ '=; Max-Age=0; path=/; domain=.uxi.kr';
                this.updateChannelTalk();

                alert("로그아웃 되었습니다");
                this.$router.push("/");
            }
        },
        "user._id"(){
            this.updateChannelTalk();
        },
        "$route.path"() {
            this.getLogo();
        },
        refid() {
            this.setRefid();
        },
    }        
}
</script>